const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

/**
 * Validate init data from Telegram Mini App
 * @param {string} initData - The init data string from Telegram WebApp
 * @returns {Promise<Object>} Validation result with user data
 */
export async function validateInitData(initData) {
  if (!initData) {
    throw new Error('Init data tidak tersedia')
  }

  try {
    const response = await fetch(`${API_BASE_URL}/validate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ init_data: initData }),
    })

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.detail || `HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    if (error instanceof Error) {
      throw error
    }
    throw new Error('Terjadi error saat mengirim request ke server')
  }
}

